import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import reportGroupServices from "../services/reportGroupServices";

export const useFetchReportGroups = () => {
  return useQuery({
    queryKey: ["fetchReportGroups"],
    queryFn: () => reportGroupServices.FetchReportGroups(),
    staleTime: 1 * 60 * 1000,
  });
};

export const useCreateReportGroup = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload) => reportGroupServices.CreateReportGroup(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["fetchReportGroups"] });
    },
    onError: (error) => {
      console.error("Error creating report group:", error);
      throw error;
    },
  });
};

export const useRenameReportGroup = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ groupId, name }) => reportGroupServices.RenameReportGroup(groupId, name),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["fetchReportGroups"] });
    },
    onError: (error) => {
      console.error("Error renaming report group:", error);
      throw error;
    },
  });
};

export const useArchiveReportGroup = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ groupId, isArchived }) => reportGroupServices.ArchiveReportGroup(groupId, isArchived),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["fetchReportGroups"] });
    },
    onError: (error) => {
      console.error("Error archiving report group:", error);
      throw error;
    },
  });
};

export const useDeleteReportGroup = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ groupId }) => reportGroupServices.DeleteReportGroup(groupId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["fetchReportGroups"] });
      queryClient.invalidateQueries({ queryKey: ["fetchReports"] });
    },
    onError: (error) => {
      console.error("Error deleting report group:", error);
      throw error;
    },
  });
};

export default {
  useFetchReportGroups,
  useCreateReportGroup,
  useRenameReportGroup,
  useArchiveReportGroup,
  useDeleteReportGroup,
};
